export default "__VITE_ASSET__23326bc4__"